<div class="john-div">
  <h1 class="john">John Allison</h1>
  <h2 class="subheading">{{bio}}</h2>
  <h2 class="subheading"><i>Click To Draw!</i></h2>
</div>
